import React, { useRef, useState } from 'react';
import { FiImage, FiRefreshCw, FiUploadCloud } from 'react-icons/fi';
import { normalizeUploadedImageUrl, uploadImage } from 'apis/uploadImage';

const ImageUploadField = ({ value = '', onChange, folder = 'projects', label = 'Hình ảnh chính', showUrl = true }) => {
    const inputRef = useRef(null);
    const [uploading, setUploading] = useState(false);
    const [error, setError] = useState('');
    const previewUrl = normalizeUploadedImageUrl(value);

    const handleFile = async (file) => {
        if (!file) return;
        if (!file.type.startsWith('image/')) {
            setError('Vui lòng chọn đúng định dạng ảnh.');
            return;
        }
        setUploading(true);
        setError('');
        try {
            onChange(await uploadImage(file, { folder }));
        } catch (uploadError) {
            setError(uploadError.message || 'Không thể tải ảnh lên.');
        } finally {
            setUploading(false);
        }
    };

    return (
        <div className="image-upload-field">
            <label className="image-upload-field__label">{label}</label>
            <div
                className={`image-upload-field__dropzone ${previewUrl ? 'has-preview' : ''}`}
                onDragOver={(event) => event.preventDefault()}
                onDrop={(event) => {
                    event.preventDefault();
                    handleFile(event.dataTransfer.files?.[0]);
                }}
            >
                <input
                    ref={inputRef}
                    type="file"
                    accept="image/png,image/jpeg,image/webp,image/gif,image/svg+xml"
                    hidden
                    onChange={(event) => handleFile(event.target.files?.[0])}
                />
                {previewUrl ? (
                    <div className="image-upload-field__preview">
                        <img src={previewUrl} alt="Xem trước ảnh" />
                    </div>
                ) : (
                    <span className="image-upload-field__icon"><FiUploadCloud /></span>
                )}
                <div className="image-upload-field__copy">
                    <div className="image-upload-field__title">{previewUrl ? 'Thay ảnh khác' : 'Kéo thả hoặc chọn ảnh'}</div>
                    <div className="image-upload-field__hint">PNG, JPG, WEBP, GIF, SVG · tối đa 5 MB</div>
                </div>
                <button type="button" className="image-upload-field__button" disabled={uploading} onClick={() => inputRef.current?.click()}>
                    {uploading ? <><FiRefreshCw className="spin" /> Đang tải</> : 'Chọn tệp'}
                </button>
            </div>
            {showUrl && (
                <div className="image-upload-field__url">
                    <span><FiImage /></span>
                    <div>
                        <div className="image-upload-field__url-label">Hoặc URL ảnh bên ngoài</div>
                        <input
                            type="text"
                            value={value || ''}
                            onChange={(event) => onChange(event.target.value)}
                            placeholder="https://... hoặc /uploads/..."
                        />
                    </div>
                </div>
            )}
            {error && <p className="field-error">{error}</p>}
        </div>
    );
};

export default ImageUploadField;
